const typeTemplate = '${label} ایک درست ${type} نہیں ہے'
const urPK = {
  locale: 'ur-PK',
  common: {
    confirm: 'تصدیق کریں',
    cancel: 'منسوخ کریں',
    loading: 'لوڈ ہو رہا ہے',
    close: 'بند کریں'
  },
  Calendar: {
    title: 'تاریخ کا انتخاب',
    confirm: 'تصدیق کریں',
    start: 'آغاز',
    end: 'اختتام',
    today: 'آج',
    markItems: ['ایک', 'دو', 'تین', 'چار', 'پانچ', 'چھ', 'اتوار'],
    yearAndMonth: '${year} سال ${month} مہینہ'
  },
  Cascader: {
    placeholder: 'براہ مہربانی منتخب کریں'
  },
  Dialog: {
    ok: 'مجھے معلوم ہے'
  },
  DatePicker: {
    tillNow: 'اب تک'
  },
  ErrorBlock: {
    default: {
      title: 'صفحے میں کچھ مسئلہ آ گیا ہے',
      description: 'کچھ دیر بعد دوبارہ کوشش کریں'
    },
    busy: {
      title: 'آگے بھیڑ ہے',
      description: 'ریفریش کر کے دیکھیں'
    },
    disconnected: {
      title: 'نیٹ ورک کچھ مصروف ہے',
      description: 'اپنے ہاتھ سے درست کرنے کی کوشش کریں'
    },
    empty: {
      title: 'آپ کی مطلوبہ چیز نہیں ملی',
      description: 'کوئی اور تلاش کریں'
    }
  },
  Form: {
    required: 'لازمی',
    optional: 'اختیاری',
    defaultValidateMessages: {
      default: 'فیلڈ تصدیق میں غلطی ${label}',
      required: 'براہ مہربانی ${label} درج کریں',
      enum: '${label} لازمی ان میں سے ایک ہو [${enum}]',
      whitespace: '${label} خالی کردار نہیں ہو سکتا',
      date: {
        format: '${label} کی تاریخ کا فارمیٹ غلط ہے',
        parse: '${label} تاریخ میں تبدیل نہیں ہو سکتا',
        invalid: '${label} ایک غلط تاریخ ہے'
      },
      types: {
        string: typeTemplate,
        method: typeTemplate,
        array: typeTemplate,
        object: typeTemplate,
        number: typeTemplate,
        date: typeTemplate,
        boolean: typeTemplate,
        integer: typeTemplate,
        float: typeTemplate,
        regexp: typeTemplate,
        email: typeTemplate,
        url: typeTemplate,
        hex: typeTemplate
      },
      string: {
        len: '${label} لازمی ${len} حروف کا ہو',
        min: '${label} کم از کم ${min} حروف کا ہونا چاہیے',
        max: '${label} زیادہ سے زیادہ ${max} حروف کا ہونا چاہیے',
        range: '${label} لازمی ${min}-${max} حروف کے درمیان ہو'
      },
      number: {
        len: '${label} لازمی ${len} کے برابر ہو',
        min: '${label} کم از کم قیمت ${min} ہے',
        max: '${label} زیادہ سے زیادہ قیمت ${max} ہے',
        range: '${label} لازمی ${min}-${max} کے درمیان ہو'
      },
      array: {
        len: 'لازمی ${len} ${label} ہو',
        min: 'کم از کم ${min} ${label} ہونا چاہیے',
        max: 'زیادہ سے زیادہ ${max} ${label} ہونا چاہیے',
        range: '${label} کی تعداد ${min}-${max} کے درمیان ہونی چاہیے'
      },
      pattern: {
        mismatch: '${label} پیٹرن سے مطابقت نہیں رکھتا ${pattern}'
      }
    }
  },
  ImageUploader: {
    uploading: 'اپ لوڈ ہو رہا ہے...',
    upload: 'اپ لوڈ کریں'
  },
  InfiniteScroll: {
    noMore: 'مزید کچھ نہیں',
    failedToLoad: 'لوڈ کرنے میں ناکام',
    retry: 'دوبارہ لوڈ کریں'
  },
  Input: {
    clear: 'صاف کریں'
  },
  Mask: {
    name: 'پس منظر کا ماسک'
  },
  Modal: {
    ok: 'مجھے معلوم ہے'
  },
  PasscodeInput: {
    name: 'پاس ورڈ ان پٹ باکس'
  },
  PullToRefresh: {
    pulling: 'ریفریش کرنے کے لیے نیچے کھینچیں',
    canRelease: 'فوراً ریفریش کرنے کے لیے چھوڑیں',
    complete: 'ریفریش کامیاب'
  },
  SearchBar: {
    name: 'تلاش کا باکس'
  },
  Slider: {
    name: 'سلائیڈر ان پٹ بار'
  },
  Stepper: {
    decrease: 'کم کریں',
    increase: 'زیادہ کریں'
  },
  Switch: {
    name: 'سوئچ'
  },
  Selector: {
    name: 'انتخاب گروپ'
  }
}
export default urPK
